var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-hamburger",class:{ open: _vm.statusHamburger },on:{"click":_vm.toggleHamburger}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }